module.exports = __webpack_public_path__ + "img/login-logo.b03ba3c6.png";